import { Box, Label } from '@acv/clearcar-component-lib';

import { Icon, Tooltip } from '@portal/ui';
import { styled } from '@portal/ui/lib';

const SectionCardActionButton = ({
  buttonIconName,
  isButtonDisabled,
  buttonId,
  handleClick,
  buttonText,
}) => (
  <Box isFlex align="center">
    {buttonIconName && (
      <Icon
        icon={buttonIconName}
        color={isButtonDisabled ? 'disabled' : '#00558c'}
        size="md2"
        marginRight="4px"
        isClickable={!isButtonDisabled}
      />
    )}
    <SectionCardButton
      id={buttonId}
      color="primary-success"
      onClick={handleClick}
      isDisabled={isButtonDisabled}
    >
      {buttonText}
    </SectionCardButton>
  </Box>
);

const SectionCard = ({
  buttonText = '',
  buttonId,
  cardHeader = '',
  children = [],
  handleClick = () => {},
  headerStyle = {},
  isButtonDisabled = false,
  childPadding = '',
  showToolTip = false,
  toolTipTitle = '',
  buttonIconName,
  headerActions = null,
}) => {
  const buttonProps = {
    buttonIconName,
    isButtonDisabled,
    buttonId,
    handleClick,
    buttonText,
  };

  return (
    <CardContainer>
      <HeaderContainer
        justify="space-between"
        align="center"
        paddingRight="lg"
        paddingVertical="sm"
      >
        {cardHeader && (
          <Label margin="lg" weight="semibold" {...headerStyle}>
            {cardHeader}
          </Label>
        )}
        <Box isFlex align="center" gap="md">
          {buttonText &&
            buttonId &&
            (showToolTip ? (
              <Tooltip title={toolTipTitle} size="xs">
                <SectionCardActionButton {...buttonProps} />
              </Tooltip>
            ) : (
              <SectionCardActionButton {...buttonProps} />
            ))}
          {headerActions}
        </Box>
      </HeaderContainer>
      <Box padding={childPadding || 'xl'}>{children}</Box>
    </CardContainer>
  );
};

export default SectionCard;

const CardContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.color.ACVBgLm.background3Color};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.backgrounds.white};
`;

const HeaderContainer = styled(Box)`
  border-bottom: 1px solid
    ${({ theme }) => theme.color.ACVBgLm.background3Color};
  background-color: ${({ theme }) => theme.color.raw.gray2};
  border-radius: 8px 8px 0 0;
`;

const SectionCardButton = styled(Label)`
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  font-weight: 500;
  font-size: 14px;
  opacity: ${(props) => (props.isDisabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;
